<template lang="pug">
div
  app-modal-visualiza-pdf(
    v-if="showModalVisualizaPdf",
    @closeModal="closeModalVisualizaPdf",
    :titulo="tituloModal",
    :tipo="tipoModal",
    :isNotId="isNotId",
    :tituloDocumento="tituloDocumento"
    :isImagem="isImagem"
    :conteudo="conteudoModal",
    :conteudoSemId="conteudoModalSemid"
    :isVTN="false",
    :arrayBuffer="bytes"
  )
  app-divider(label="Documentos", :addMarginTop="addMarginTop")
  .px-10
    el-table(
      :cell-style="{padding: '0', height: '5px'}"
      :data="documentosListar"
      :class="compararDocumentos ? 'text' : '' "

    )
      template(slot-scope="scope")
        el-table-column.tes(label="Tipo de documento", :formatter="getTipo")
        el-table-column(label="Nome do arquivo:" :formatter="getNomeDocumento")
        el-table-column(label="Ações", prop="valor", width="85")
          template(slot-scope="scope")
            div.flex-space-between
              app-action-button(
                v-if="visualizarDocumentosPDF && !isEstadoMA()"
                icone="eye",
                :text="verificarTooltip(scope.row)",
                fontSize="18",
                :disabled="(!isDocumentoParaVisualizacao(scope.row) && (!isDocumentoAutenticavel(scope.row) && ownerDocumento !== 'GESTAO_DOCUMENTOS'))"
                @click="abrirPdf(scope.row)"
                :class="(!isDocumentoParaVisualizacao(scope.row) && (!isDocumentoAutenticavel(scope.row) && ownerDocumento !== 'GESTAO_DOCUMENTOS')) && 'btn-disabled'"
              )
              app-action-button(
                v-if="isEstadoMA()"
                :disabled="!isDocumentoParaVisualizacao(scope.row)"
                :cor="!isDocumentoParaVisualizacao(scope.row) ? '#C0C4CC' : '#666666'",
                icone="eye",
                :text="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar' ",
                fontSize="18",
                @click="abrirDocumento(scope.row)"
              )
              app-action-button(
                v-if="scope.row.protocolo == undefined || scope.row.protocolo == null"
                icone="download",
                text="Download",
                fontSize="18",
                @click="baixarDocumento(scope.row)"
                posicaoTooltip="left"
              )
  .px-10(v-if="isDetalhes && !isEstadoMA")
    .container-checkbox.termo-compromisso
      el-checkbox(disabled, v-model='confirmado')
        span.breakText &nbsp {{texto}}
</template>
<script>
import { mapActions } from 'vuex'
import AppActionButton from '../AppActionButton'
import AppDivider from '@/components/AppDivider'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import utils from '@/utils/utils'

const {visualizarDocumentosPDF} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  props: {
    documentos: {
      Type: Array,
      require: true
    },
    documentosColetivoisReurb: {
      Type: Array,
      require: false,
      default: () => []
    },
    documentosGeo: {
      Type: Array,
      require: true
    },
    protocoloCadastroOriginal: {
      Type: String,
      required: true
    },
    ownerDocumento: {
      Type: String,
      required: true
    },
    idMembroComunidade: {
      Type: Number,
      required: false
    },
    idBeneficiario: {
      Type: Number,
      required: false
    },
    idDependente: {
      Type: Number,
      required: false
    },
    idSocio: {
      Type: Number,
      required: false
    },
    isDetalhes: {
      Type: Boolean,
      required: false,
      default: false
    },
    interessado: {
      Type: Object,
      required: false
    },
    tempoOcupacao: {
      Type: String,
      required: false
    },
    addMarginTop: {
      Type: Boolean,
      default: true
    },
    isBeneficiario: {
      Type: Boolean,
      default: false
    },
    compararDocumentos: {
      type: Boolean,
      required: false
    },
    idInteressado: {
      Type: Number,
      required: false
    },
    versaoCadastro: {
      type: String,
      default: 'MAX(versao_json)'
    },
    isCadastroPendente: {
      type: Boolean,
      default: false
    }
  },

  components: {
    AppActionButton,
    AppDivider,
    AppModalVisualizaPdf
  },

  mounted () {
    if (this.interessado) {
      this.setTexto()
    }
    this.visualizarDocumentosPDF = visualizarDocumentosPDF.active
  },

  data () {
    return {
      confirmado: true,
      isNotId: false,
      texto: '',
      conteudoModal: '',
      conteudoModalSemid: null,
      tituloModal: '',
      isImagem: false,
      tipoModal: '',
      showModalVisualizaPdf: false,
      bytes: null
    }
  },

  computed: {
    documentosListar () {
      if (this.documentosGeo && this.documentosGeo !== undefined) {
        return this.documentos.concat(this.documentosGeo)
      } else {
        const temCRF = this.documentos.some(doc => doc?.tipo?.codigo === 'CRF')
        return temCRF ? this.documentos : [...this.documentos, ...this.documentosColetivoisReurb]
      }
    }
  },

  methods: {
    ...mapActions({
      baixarDocumentoOriginal: 'cadastro/downloadDocumentoOriginal',
      downloadDocumento: 'download/downloadDocument',
      download: 'gestaoDocumentos/download',
      getBytesDocumento: 'gestaoDocumentos/getBytesDocumento'
    }),
    setTexto () {
      if (this.interessado.pessoa.isPessoaFisica && this.interessado.pessoa.pessoaFisica.municipio) {
        this.texto = `Eu, ${this.interessado.pessoa.pessoaFisica.nome}, CPF nº ${this.interessado.pessoa.pessoaFisica.cpf}, DECLARO para os devidos fins, sob as penas da lei, ocupo imóvel rural
        identificado neste requerimento do Instituto de Terras do Pará – ITERPA, no município de ${this.interessado.pessoa.pessoaFisica.municipio.nome}, tornando
        produtivo há ${this.tempoOcupacao} anos, e preencho os requisitos estabelecidos na Lei 7.289/2009, e demais normas que a regulamentam.`
      } else if (!this.interessado.pessoa.isPessoaFisica) {
        this.texto = `Eu, ${this.interessado.pessoa.pessoaJuridica.razaoSocial}, CNPJ nº ${this.interessado.pessoa.pessoaJuridica.cnpj}, DECLARO para os devidos fins, sob as penas da lei, ocupo imóvel rural
        identificado neste requerimento do Instituto de Terras do Pará – ITERPA, no município de ${this.interessado.pessoa.endereco.municipio.nome}, tornando
        produtivo há ${this.tempoOcupacao} anos, e preencho os requisitos estabelecidos na Lei 7.289/2009, e demais normas que a regulamentam.`
      }
    },
    getTipo (row) {
      if (this.ownerDocumento === 'GESTAO_DOCUMENTOS') {
        return this.documentosGestao(row.tipo)
      } else if (row.tipo) {
        return row.tipo.nome || row.tipo.descricao || this.documentoDeclaracoes(row.nome)
      } else if (row.tipoDocumento) {
        return row.tipoDocumento.descricao
      } else if (row.tipoDocumentoAutenticavel) {
        return row.tipoDocumentoAutenticavel.descricao
      } else {
        return '-'
      }
    },
    documentoDeclaracoes (nomeDocumento) {
      if (nomeDocumento === 'declaracao_posse_residencia') {
        return 'Declaração de residência'
      } else if (nomeDocumento === 'declaracao_posse_imovel') {
        return 'Declaração de posse do imóvel'
      }
    },
    documentosGestao (tipoDocumento) {
      if (tipoDocumento === 'DRP') {
        return 'Declaração de reconhecimento de posse'
      } else {
        return 'Outros'
      }
    },

    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    isExtensaoImagem (row) {
      let extensao = utils.getExtensionFile(row.nome || row.fileName)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.fileName || row.nome)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao) || this.isDocumentoTipoDeclaracoesReurb(row)
    },
    isDocumentoTipoDeclaracoesReurb (row) {
      return ['declaracao_posse_imovel', 'declaracao_posse_residencia'].includes(row.nome)
    },
    getNomeDocumento (value) {
      if (value.nome) {
        return value.nome
      } else if (value.nomeArquivo) {
        return value.nomeArquivo
      }
      const pathArray = value && value.caminho ? value.caminho.split('/') : []
      return pathArray.length > 0 ? pathArray[pathArray.length - 1] : '-'
    },

    baixarDocumento (documentoOriginal) {
      if (this.ownerDocumento === 'GESTAO_DOCUMENTOS') {
        this.download(documentoOriginal)
      } else if (this.isBeneficiario) {
        this.baixarDocumentoDoCaminhoSalvo(documentoOriginal)
      } else {
        const params = {
          documento: documentoOriginal,
          idDocumento: documentoOriginal._id || documentoOriginal.id,
          idCadastro: this.protocoloCadastroOriginal,
          owner: this.ownerDocumento,
          idMembroComunidade: this.idMembroComunidade,
          idSocio: this.idSocio,
          idBeneficiario: this.idBeneficiario,
          idDependente: this.idDependente,
          idInteressado: this.idInteressado,
          versao: this.versaoCadastro,
          isCadastroPendente: this.isCadastroPendente
        }
        this.baixarDocumentoOriginal(params)
      }
    },

    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    },

    async abrirPdf (documento) {
      if (process.env.ESTADO === 'pa' && process.env.NODE_ENV.includes('production') && documento.caminho) {
        const base = process.env.ROOT_URL.replace('analise/', '')
        const diretorio = documento.caminho.includes('sicarf-pa') ? 'sicarf-pa' : 'sicarf'
        window.open(`${base}${diretorio}${documento.caminho.split(diretorio)[1]}`, documento?.tipoDocumentoAutenticavel?.descricao || 'Download', 'height=500,width=800,top=250px,left=250px,right=150px')

        return
      }

      if (this.ownerDocumento === 'GESTAO_DOCUMENTOS') {
        this.tituloModal = 'Visualizar Documento'
        this.tituloDocumento = documento.nome
        this.isImagem = this.abrirImagem(documento)

        this.bytes = await this.getBytesDocumento(documento)
        this.showModalVisualizaPdf = true

        return
      }

      if (this.isDocumentoAutenticavel(documento)) {
        this.tipoModal = 'DOCUMENTO_AUTENTICAVEL'
        const { id } = documento
        this.conteudoModal = id
        this.isNotId = false
      } else {
        if (!documento.id) {
          this.conteudoModal = documento.caminho
          this.isNotId = true
          this.tipoModal = 'DOCUMENTO'
        } else {
          this.isNotId = false
          this.conteudoModal = documento.id
          this.tipoModal = 'DOCUMENTO'
        }
      }

      this.tituloModal = 'Visualizar Documento'
      this.tituloDocumento = documento.fileName
      this.showModalVisualizaPdf = true
      this.isImagem = this.abrirImagem(documento)
    },

    abrirDocumento (documento) {
      if (!documento.protocolo) {
        this.tituloModal = 'Visualizar Documento'
        this.tipoModal = 'DOCUMENTO_SEM_ID'
        this.conteudoModal = 0
        this.isImagem = this.isExtensaoImagem(documento)
        this.conteudoModalSemid = documento.caminhoDisco ? documento : {caminho: documento.caminho}
        this.showModalVisualizaPdf = true
        this.tituloDocumento = documento.tipo.descricao
        return
      }

      this.tipoModal = 'DOCUMENTO_AUTENTICAVEL'
      this.tituloModal = documento.tipoDocumentoAutenticavel.descricao
      this.conteudoModal = documento.id
      this.showModalVisualizaPdf = true
      this.isImagem = this.abrirImagem(documento)
    },

    async baixarDocumentoDoCaminhoSalvo (documento) {
      if (process.env.ESTADO === 'pa' && process.env.NODE_ENV.includes('production') && documento.caminho) {
        const base = process.env.ROOT_URL.replace('analise/', '')
        const diretorio = documento.caminho.includes('sicarf-pa') ? 'sicarf-pa' : 'sicarf'
        window.open(`${base}${diretorio}${documento.caminho.split(diretorio)[1]}`, documento?.tipoDocumentoAutenticavel?.descricao || 'Download', 'height=500,width=800,top=250px,left=250px,right=150px')

        return
      }
      documento.id = null
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.fileName)
    },

    abrirImagem (row) {
      if (this.isDocumentoAutenticavel(row)) {
        return false
      }
      let extensao = row.formato || utils.getExtensionFile(row.nome ? row.nome : row.fileName)

      if (visualizarDocumentosPDF.extensaoImagens.includes(extensao)) {
        return true
      } else {
        return false
      }
    },

    isDocumentoAutenticavel (row) {
      const { tipoDocumentoAutenticavel } = row
      if (tipoDocumentoAutenticavel) {
        return true
      }
    },

    verificarTooltip (row) {
      if (this.isDocumentoAutenticavel(row)) {
        return 'Visualizar Documento'
      }
      const extensao = row.formato || utils.getExtensionFile(row.nome ? row.nome : row.fileName)
      if (!visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)) {
        return 'Não é possível exibir esse arquivo'
      } else {
        return 'Visualizar Documento'
      }
    },
    verificarExtensao (row) {
      if (this.isDocumentoAutenticavel(row)) {
        return false
      }
      const extensao = utils.getExtensionFile(row.nome ? row.nome : row.fileName)
      if (visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style lang="scss" scoped>

  $--color-primary: #009f61; // Importar o variables e retirar esta variavel quando juntar com o analise
  $font-color: #606266;
  $font-size-small: 0.875em;

.pad5 {
  padding: 10px 0;
}
.px-10 {
  padding: 0 10px;
}
.termo-compromisso {
  margin-top: 20px;
  padding: 10px;
  background-color: #f3f7fa;
  border-radius: 4px;
}
.breakText {
  white-space: normal; display: block;
}
.flex-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.container-checkbox {
  margin-top: 10px;

  .el-checkbox {
    padding-right: 10px;
  }

  span {
    color: $font-color;
    font-size: $font-size-small;

    &.checked {
      color: $--color-primary;
    }
  }

}

.btn-disabled {
  opacity: 0.4;

  &:hover {
    color: #C0C4CC !important;
  }
}

.btn-actions {
  margin-right: 15px;
}

.button-container {
  display: flex;
  justify-content: flex-end
}

.button {
  border: none;
  background: none;
  padding: 0;
}

.button-right {
  margin-left: auto;
}
>>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/ListagemDocumentos.vue